<app-dialog-header
  [header]="'library.user_card.dialog.user_certificates_form.header' | translate"
  iconClass="icon-generate-certificate-icon"
>
</app-dialog-header>
<app-dialog-content>
  <div
    [formGroup]="form"
    [spinner]="loadingData"
  >
    <div class="view">
      <div class="p-grid basic-form-box">
        <div class="p-col-12 form-control-container">
          <div class="p-grid p-align-end">
            <div class="p-col-12 p-md-6">
              <app-form-control-label [control]="form.get('signing')">
                {{ 'library.user_card.dialog.user_certificates_form.signing_mail.label' | translate }}:
              </app-form-control-label>
              <p class="file-name text-ellipsis">
              <span
                [hidden]="!isSigningCertificateSelected()"
                [title]="'library.user_card.dialog.user_certificates_form.certificate_uploaded.label' | translate"
              >
                {{ 'library.user_card.dialog.user_certificates_form.certificate_uploaded.label' | translate }}
              </span>
                <span [hidden]="isSigningCertificateSelected()">{{ 'upload.not_selected' | translate }}</span>
              </p>
              <div class="button-container">
                <app-file-select
                  [displayInfo]="false"
                  [formControl]="form.get('signing.file')"
                  [maxFileSize]="maxCertificateFileSize"
                  accept=".p12,.pfx"
                  data-qa="user-certificates-form-signing-certificate-file-select"
                >
                </app-file-select>
                <button
                  [disabled]="!isSigningCertificateSelected()"
                  (click)="removeSigningCertificate()"
                  data-qa="user-certificates-form-signing-certificate-remove-button"
                  type="button"
                  class="proget-button remove-cert-button"
                >
                  {{ 'button.delete.label' | translate }}
                </button>
              </div>
            </div>
            <div class="p-col-12 p-md-6 form-control-container">
              <app-form-control-label [control]="form.get('signing.password')">
                {{ 'common.password' | translate }}:
              </app-form-control-label>
              <app-password
                [formControl]="form.get('signing.password')"
                [optional]="false"
                data-qa="user-certificates-form-signing-certificate-password-input"
              ></app-password>
            </div>
            <app-form-control-error
              [control]="form.get('signing')"
              [errors]="errors.signing"
              class="certificate-error"
            ></app-form-control-error>
          </div>
        </div>
        <div class="p-col-12 form-control-container">
          <div class="p-grid p-align-end">
            <div class="p-col-12 p-md-6">
              <app-form-control-label [control]="form.get('encryption')">
                {{ 'library.user_card.dialog.user_certificates_form.encrypt_mail.label' | translate }}:
              </app-form-control-label>
              <p class="file-name text-ellipsis">
              <span
                [hidden]="!isEncryptionCertificateSelected()"
                [title]="'library.user_card.dialog.user_certificates_form.certificate_uploaded.label' | translate"
              >
                {{ 'library.user_card.dialog.user_certificates_form.certificate_uploaded.label' | translate }}
              </span>
                <span [hidden]="isEncryptionCertificateSelected()">{{ 'upload.not_selected' | translate }}</span>
              </p>
              <div class="button-container">
                <app-file-select
                  [displayInfo]="false"
                  [formControl]="form.get('encryption.file')"
                  [maxFileSize]="maxCertificateFileSize"
                  accept=".p12,.pfx"
                  data-qa="user-certificates-form-encryption-certificate-file-select"
                >
                </app-file-select>
                <button
                  [disabled]="!isEncryptionCertificateSelected()"
                  (click)="removeEncryptionCertificate()"
                  data-qa="user-certificates-form-encryption-certificate-remove-button"
                  type="button"
                  class="proget-button remove-cert-button"
                >
                  {{ 'button.delete.label' | translate }}
                </button>
              </div>
            </div>
            <div class="p-col-12 p-md-6">
              <app-form-control-label [control]="form.get('encryption.password')">
                {{ 'common.password' | translate }}:
              </app-form-control-label>
              <app-password
                [formControl]="form.get('encryption.password')"
                [optional]="false"
                data-qa="user-certificates-form-encryption-certificate-password-input"
              ></app-password>
            </div>
            <app-form-control-error
              [control]="form.get('encryption')"
              [errors]="errors.encryption"
              class="certificate-error"
            ></app-form-control-error>
          </div>
          <app-form-control-error [control]="form"></app-form-control-error>
        </div>
      </div>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer align-right">
  <button
    (click)="close()"
    data-qa="user-certificates-form-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [disabled]="requestPending"
    [submitButton]="form"
    (click)="submit()"
    data-qa="user-certificates-form-submit-button"
    type="submit"
    class="proget-button text-only primary-button"
  >
    {{ 'button.submit.label' | translate }}
  </button>
</div>
